<template>
  <div class="status-element">
    <div
      v-for="status in statusArray"
      :key="status.key"
      :class="['loader--' + status.type]"
      class="g-btn g-btn--rounded loader"
      @click="removeStatus(status)"
    >
      <span
        class="loader__text"
      >
        <font-awesome-icon
          v-if="status.icon"
          :icon="[status.icon.pack, status.icon.name]"
          class="icon"
        />
        <span>{{ status.type }}</span>
        <span>{{ status.message }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  name: 'StatusElement',
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  props: {
    PageMessage: {
      default: function() {
        return {
          target: '',
          type: '',
          data: null
        }
      },
      type: Object
    }
  },
  data() {
    return {
      statusArray: [],
      types: {
        saving: {
          autoRemove: 2000,
          icon: {
            pack: 'fas',
            name:'plus'
          }
        },
        completed: {
          autoRemove: 3000,
          icon: {
            pack: 'fas',
            name:'check'
          }
        },
        error: {
          autoRemove: null,
          icon: {
            pack: 'fas',
            name:'times'
          }
        }
      }
    }
  },
  watch: {
    PageMessage(message) {
      if(message.target === this.$options.name) {
        let statusObject = this.messageToStatus(message)

        if(statusObject.autoRemove) {
          if(statusObject.type !== 'saving') { // @HACK: cheaty Mc CheatyFace
            this.$set(statusObject, '_autoRemoval', setInterval(() => {
              clearInterval(statusObject._autoRemoval)

              this.removeStatus(statusObject)
            }, statusObject.autoRemove))
          } else {
            this.$set(statusObject, '_autoRemoval', setInterval(() => {
              clearInterval(statusObject._autoRemoval)

              Object.assign(statusObject, this.types['completed'], {type: 'completed'})

              this.$set(statusObject, '_autoRemoval', setInterval(() => {
                clearInterval(statusObject._autoRemoval)
                this.removeStatus(statusObject)
              }, statusObject.autoRemove))
            }, statusObject.autoRemove))
          }
        }

        statusObject
        ? this.statusArray.push(statusObject)
        : console.warn('no status for this call')
      }
    }
  },
  methods: {
    messageToStatus(status) {
      return Object.assign({}, status, this.types[status.type], {
        key: Date.now(),
        message: `${status.data ? ' ' + status.data : ''}`,
      })
    },
    removeStatus(status) {
      this.statusArray.splice(this.statusArray.indexOf(status), 1)
    }
  }
}
</script>

<style lang="scss">
.status-element {
  $loaderOffset: 45px;
  position: absolute;
  top: $loaderOffset;
  right: 20px;
  z-index: $z-modal+10;
  display: grid;
  grid-template-columns: 1fr;

  .icon {
    margin-right: 10px;
  }
  .g-btn {
    box-sizing: border-box;
    align-items: center;
    transition: all 0.4s;
    overflow: hidden;
    background: $color-white;

    &.loader {
      padding: 10px;
      margin: 2px 0;
      &--completed {
          background: $color-button-blue;
          color: #fff;
      }

      &--error {
          background: $color-red-error;
          color: #fff;
      }
    }
  }
}
</style>
